[
    {
        "org_name": "Artmeet.my",
        "org_logo": "https://drive.google.com/thumbnail?id=1fdeHryZ1IyI92DYK-NV_knKmhEM_CbBs",
        "org_website": "https://www.artmeet.my/",
        "type": "media"
    },
    {
        "org_name": "Ugek",
        "org_logo": "https://drive.google.com/thumbnail?id=1Wz530K5K50mQHp1HqrZ3kJ2Nc7wfh7h7",
        "org_website": "https://ugek.my/",
        "type": "media"
    },
    {
        "org_name": "UniLah.",
        "org_logo": "https://drive.google.com/thumbnail?id=1cK0lMHif_ARgbdtIolB-EA5OkVXaapHo",
        "org_website": "https://linktr.ee/myunilah",
        "type": "media"
    },
    {
        "org_name": "The Malaysian Hub",
        "org_logo": "https://drive.google.com/thumbnail?id=14TDY1t5saDqBzlMGVzCxbcWB3SLYoI_c",
        "org_website": "https://linktr.ee/msiaevents",
        "type": "media"
    },
    {
        "org_name": "WeirdKaya - Headline Media Sdn Bhd",
        "org_logo": "https://drive.google.com/thumbnail?id=1chy1xeN_5OvHXYUk0Jmmzgr0ykVqvy58",
        "org_website": "https://lnk.bio/WeirdKaya",
        "type": "media"
    },
    {
        "org_name": "GoMonsta Asia Sdn Bhd",
        "org_logo": "https://drive.google.com/thumbnail?id=1iOse04TJtPtRhDRqqmatAldJSBJwvE5I",
        "org_website": "https://community.gomonsta.asia/",
        "type": "strategic"
    },
    {
        "org_name": "Malaysian Youth FinTech Association (MYFinT)",
        "org_logo": "https://drive.google.com/thumbnail?id=1ZGlAlA50ZrtLAwPve92zXC3UAk7PQop6",
        "org_website": "https://www.myfint.org/",
        "type": "supporting"
    },
    {
        "org_name": "Malaysian Finance Expert Convention (MFEC)",
        "org_logo": "https://drive.google.com/thumbnail?id=1TRHHs0Y_erYeIXERQag0-7O7osZXAOGx",
        "org_website": "https://www.mfec2022.com/",
        "type": "synergy"
    },
    {
        "org_name": "FortNynja",
        "org_logo": "https://drive.google.com/thumbnail?id=1er72NZNaXZqempVtlDhdXZ_JpClsSsVV",
        "org_website": "https://www.fortnynja.com/",
        "type": "ecosystem"
    },
    {
        "uni_name": "Imperial College London",
        "uni_logo": "https://drive.google.com/thumbnail?id=1fDLVj9pcwe4ccIR3e3ZWkDCDx_5NGAjf",
        "org_name": "FinTech Society Imperial College London",
        "org_logo": "https://drive.google.com/thumbnail?id=1A8SUmD58xoBXf38pIbraSGXzHxoYrzVt",
        "org_website": "https://www.linkedin.com/company/icfintech",
        "type": "program"
    },
    {
        "uni_name": "University Of Amikom Yogyakarta",
        "uni_logo": "https://drive.google.com/thumbnail?id=1kfaNvat5giVtpRfTjw9UFb44UnE0HE9h",
        "org_name": "Amikom Computer Club",
        "org_logo": "https://drive.google.com/thumbnail?id=1fGfywnQJyVhSWlmEJDtMldbhRw03Te7P",
        "org_website": "https://amcc.or.id/",
        "type": "program"
    },
    {
        "uni_name": "Asia Pacific University Of Technology & Innovation (apu)",
        "uni_logo": "https://drive.google.com/thumbnail?id=1zvMOg_FQiXHVf09aWfXXNPyjkrL_iL6z",
        "org_name": "APU Forensic & Cybersecurity Research Centre - Student Section",
        "org_logo": "https://drive.google.com/thumbnail?id=1NomWQlFeWu5D4Um_MYfIjYTNW4D--hY_",
        "org_website": "https://www.linkedin.com/company/forensic-security-research-center-student-section-apu/",
        "type": "program"
    },
    {
        "uni_name": "Universitas Brawijaya",
        "uni_logo": "https://drive.google.com/thumbnail?id=1SbZkBJXNFjQFRrOQi4jK_B6ZAM2OPXi9",
        "org_name": "Basic Computing Community Universitas Brawijaya",
        "org_logo": "https://drive.google.com/thumbnail?id=1Fl7gBVkdw_BJJIffNUqtHJ6r4YLoQMs1",
        "org_website": "https://bccfilkom.net/",
        "type": "program"
    },
    {
        "uni_name": "Universiti Teknologi Mara Shah Alam",
        "uni_logo": "https://drive.google.com/thumbnail?id=1J7t5vSPVRkD88i8L05iEw-aa1a0q-5it",
        "org_name": "Computer Science Club Universiti Teknologi MARA Shah Alam",
        "org_logo": "https://drive.google.com/thumbnail?id=1v_7AXJXPtuTmNMaS2cdArxMYCIzrTf0c",
        "org_website": "https://www.instagram.com/csclub__",
        "type": "program"
    },
    {
        "uni_name": "Tunku Abdul Rahman University College",
        "uni_logo": "https://drive.google.com/thumbnail?id=18K0Imwx5r6TPNUlv97RljD3kgfQA3oP5",
        "org_name": "Computer Science Society Tunku Abdul Rahman University College",
        "org_logo": "https://drive.google.com/thumbnail?id=1j2Nwmrk0NQ16jPPUyULdtMFheB8xlIj4",
        "org_website": "https://www.tarc.edu.my/focs/",
        "type": "program"
    },
    {
        "uni_name": "University Kuala Lumpur Malaysian Institute Of Information Technology",
        "uni_logo": "https://drive.google.com/thumbnail?id=1rHNzvZ_ZVh1kR5cBPJ75ysiPU0u1gIUk",
        "org_name": "Google Developer Student Club UniKL",
        "org_logo": "https://drive.google.com/thumbnail?id=1CePEiVEpKfybh-MvcnVktmB9JREQ4pjV",
        "org_website": "https://gdsc.community.dev/universiti-kuala-lumpur/",
        "type": "program"
    },
    {
        "uni_name": "Tokyo Metropolitan University",
        "uni_logo": "https://drive.google.com/thumbnail?id=18BoKgYKhxu0Ca3Tm-oUm6j_CAL-9Hd29",
        "org_name": "Google Developer Student Club Tokyo Metropolitan University",
        "org_logo": "https://drive.google.com/thumbnail?id=1TOxbXGDKt3uUowNArsaXH76Y7Eh9E7Ho",
        "org_website": "https://gdsc.community.dev/tokyo-metropolitan-university/",
        "type": "program"
    },
    {
        "uni_name": "Conestoga College",
        "uni_logo": "https://drive.google.com/thumbnail?id=1rv0yhC4hIGhafmHaRsCmvSY4Bk0C9SvI",
        "org_name": "Google Developer Student Club @ Conestoga",
        "org_logo": "https://drive.google.com/thumbnail?id=1m5UZ-UtO1RiF8vxuFjWQqTWIeGCfTwNQ",
        "org_website": "https://gdsc.community.dev/conestoga-college-waterloo-campus/",
        "type": "program"
    },
    {
        "uni_name": "King Abdulaziz University",
        "uni_logo": "https://drive.google.com/thumbnail?id=1K-aAfvGJ74C27iYng0YoEcmP8tZLDvzu",
        "org_name": "Google Developer Students Club at King Abdulaziz University",
        "org_logo": "https://drive.google.com/thumbnail?id=11HaRLTAC_JNz__fWMovKWwVH9Z7Oobsw",
        "org_website": "https://gdsc-kau.club/",
        "type": "program"
    },
    {
        "uni_name": "Monash University Malaysia",
        "uni_logo": "https://drive.google.com/thumbnail?id=1MIo1dhcoyBTF0OAt0khaMPMQnAMQ5-3e",
        "org_name": "Google Developer Student Club Monash University Malaysia",
        "org_logo": "https://drive.google.com/thumbnail?id=1PFlWQklQFPzdetq-m_zfsmrb8hTYGMOt",
        "org_website": "https://sites.google.com/view/dscmonashmalaysia/home?authuser=0",
        "type": "program"
    },
    {
        "uni_name": "University Of Malaya",
        "uni_logo": "https://drive.google.com/thumbnail?id=1Wg-VO-poBW8iftG23bLVrc57YEO6flYn",
        "org_name": "Google Developer Student Club University of Malaya",
        "org_logo": "https://drive.google.com/thumbnail?id=1laOs6I0Xp9SXmXMwat06EO9ZX53osanV",
        "org_website": "https://gdsc.community.dev/university-of-malaya/",
        "type": "program"
    },
    {
        "uni_name": "Tamkang University",
        "uni_logo": "https://drive.google.com/thumbnail?id=1X5g1tIcb0qTNnvg2BTICQ4vOWmrOfqV6",
        "org_name": "Google Developer Student Club TamKang University",
        "org_logo": "https://drive.google.com/thumbnail?id=1svrZ1-O4QAJsIlKr45H2lDDlNPDXPuSi",
        "org_website": "https://sites.google.com/view/tkugdscen",
        "type": "program"
    },
    {
        "uni_name": "Universiti Sains Malaysia",
        "uni_logo": "https://drive.google.com/thumbnail?id=1q2SNVx-JUq3nxBQpZenqE1-VOd4YlpDP",
        "org_name": "Google Developer Student Club Universiti Sains Malaysia",
        "org_logo": "https://drive.google.com/thumbnail?id=1xiqGyl6L7D0YwlhTH3O_tFkcgSTTrYx5",
        "org_website": "https://sites.google.com/view/gdsc-usm/home",
        "type": "program"
    },
    {
        "uni_name": "Universiti Putra Malaysia",
        "uni_logo": "https://drive.google.com/thumbnail?id=1DjL3D04wYYwO4YWOWXZSaOIzv8Oo7HGd",
        "org_name": "Google Developer Student Club UPM (GDSC UPM)",
        "org_logo": "https://drive.google.com/thumbnail?id=1Fc2zoAkGEtPWkFL4dqDPgoY7HdNT9s3A",
        "org_website": "https://gdsc.community.dev/universiti-putra-malaysia-1/",
        "type": "program"
    },
    {
        "uni_name": "Universitas Gadjah Mada",
        "uni_logo": "https://drive.google.com/thumbnail?id=1Q_JyhdmFyhzFw9PjRjT0RNt9Int07VXk",
        "org_name": "Google Developer Student Club UPM (GDSC UPM)",
        "org_logo": "https://drive.google.com/thumbnail?id=1DMGhJOgdaqmg7NJpdWCLgJ5Z9UfwliE4",
        "org_website": "http://s.gdscugm.com/",
        "type": "program"
    },
    {
        "uni_name": "Universiti Malaya",
        "uni_logo": "https://drive.google.com/thumbnail?id=1XxoU4fHXmWze6ZRV_vZ9IdALvW28sq7C",
        "org_name": "University of Malaya's Student Union Faculty of Computer Science and Information Technology",
        "org_logo": "https://drive.google.com/thumbnail?id=188WZvCJfvIa2_dpaSLZMN8Ejv9lRvaWf",
        "org_website": "https://www.facebook.com/StudentUnionFCSITUniversityofMalaya/",
        "type": "program"
    },
    {
        "uni_name": "University Of The Western Cape",
        "uni_logo": "https://drive.google.com/thumbnail?id=1KACrHDs8qsBkf4SZbl0X29jhoh-FSZah",
        "org_name": "Google Developer Student Club University of the Western Cape",
        "org_logo": "https://drive.google.com/thumbnail?id=12KL_SqUo6iqIKaRIsbB16udC4ZVoidH1",
        "org_website": "https://gdsc.community.dev/university-of-the-western-cape/",
        "type": "program"
    },
    {
        "uni_name": "The University Of Hong Kong",
        "uni_logo": "https://drive.google.com/thumbnail?id=1Hu3rBghfbJ3h81PKmY-2vCgNqffzFYXy",
        "org_name": "HKU FinTech Association",
        "org_logo": "https://drive.google.com/thumbnail?id=1EWZt-1IfB25VgOlDHXbTd7mbVOYvtkiG",
        "org_website": "https://ftsa.hku.hk/",
        "type": "program"
    },
    {
        "uni_name": "Multimedia University Malacca Campus",
        "uni_logo": "https://drive.google.com/thumbnail?id=1cDg9tXp5rwTerC9AomtKY4CSdQaEh0Qt",
        "org_name": "Information Technology Society MMU Malacca",
        "org_logo": "https://drive.google.com/thumbnail?id=1qD3ycSV2Qoq0p83KZO1vwNje3qi1-ecH",
        "org_website": "https://www.instagram.com/itsocietymmumelaka/",
        "type": "program"
    },
    {
        "uni_name": "Universiti Teknologi Petronas",
        "uni_logo": "https://drive.google.com/thumbnail?id=1BC5xWUk1CGctwV9ixoGDuNv_zQrLp3wi",
        "org_name": "Institute of Electrical and Electronics Engineers Universiti Teknologi PETRONAS Student Branch",
        "org_logo": "https://drive.google.com/thumbnail?id=1_VPmllWquUemNRrDB-N0cGp4XzlVm9Vl",
        "org_website": "https://www.linkedin.com/company/ieeeutpsb/",
        "type": "program"
    },
    {
        "uni_name": "Lancaster University Ghana",
        "uni_logo": "https://drive.google.com/thumbnail?id=1Uhb3le4RspW-Hiuy4G3l83aaT2P-W4zg",
        "org_name": "Lancaster University Ghana Computer Science Society",
        "org_logo": "https://drive.google.com/thumbnail?id=1hEUGLaIkbRSLs49yWSRr8C5BMLVJSIMc",
        "org_website": "https://www.instagram.com/lug.css/",
        "type": "program"
    },
    {
        "uni_name": "Universiti Sains Malaysia",
        "uni_logo": "https://drive.google.com/thumbnail?id=1_xLOAngXTDXqXFH4uSmtqnUQ8Joy8R-1",
        "org_name": "Microsoft Learn Student Ambassadors of Universiti Sains Malaysia",
        "org_logo": "https://drive.google.com/thumbnail?id=1gMZp85IY4WVztMNUIH48WXoVgAKyOiT6",
        "org_website": "https://www.facebook.com/MicrosoftLearnStudentAmbassadors.USM/",
        "type": "program"
    },
    {
        "uni_name": "Monash University Malaysia",
        "uni_logo": "https://drive.google.com/thumbnail?id=1NsWZkRKVF8o1K_fHNJt_R7ZZ125LDILD",
        "org_name": "Monash University Malaysia Tech Club",
        "org_logo": "https://drive.google.com/thumbnail?id=1__x518mmcOWq1TPIMvxbTZDu31v0mIMB",
        "org_website": "https://www.instagram.com/mumtec.monash/",
        "type": "program"
    },
    {
        "uni_name": "Xiamen University Malaysia",
        "uni_logo": "https://drive.google.com/thumbnail?id=1x2C3diPZx-KanIJ47Ryg0tEcyyUgOW2o",
        "org_name": "XMUM Tech Club",
        "org_logo": "https://drive.google.com/thumbnail?id=10e52GEKLCXQFT6Wwqu16djSY3EfsWC5Z",
        "org_website": "https://www.linkedin.com/company/xmum-tech-club/",
        "type": "program"
    }
]
